import {createRouter} from '@tanstack/react-router';
import type {Deps} from './dependencies';
import {queryClient} from './lib/query-client';
import {routeTree} from './routeTree.gen';

export const createAppRouter = (deps: Deps) =>
  createRouter({
    routeTree,
    context: {queryClient, deps},
    defaultPreload: false,
    scrollRestoration: false,
  });

declare module '@tanstack/react-router' {
  interface Register {
    router: ReturnType<typeof createAppRouter>;
  }
}
